<template>
  <div class="sign_in_box flex flexcolumn">
    <div class="top_bg">
      <el-image class="points_top_bg" :src="iconPath('points_top_bg.png')"></el-image>
    </div>
    <div class="flex Flexalign my_integral_box">
      <el-image class="headImage" :src="userInfo.headImage"></el-image>
      <div class="user_name mx-10 toverflow">{{ userInfo.name }}</div>
      <el-image class="member_level_gold_icon" :src="userInfo.memberLevelIcon"></el-image>
      <!-- <div class="cursor_pointer integral_cenetr" @click="goIntegralCenter">积分中心</div> -->
    </div>
    <div class="progress_box">
      <el-progress :text-inside="true" :stroke-width="8" :percentage="calculateProgress(signInfo.userGrowth,signInfo.nextLevelGrowth)" status="success" :show-text="false"
        color="#00D498" />
      <div class="mt-10">成长值{{ signInfo.userGrowth || 0}}，还差{{signInfo.nextLevelGrowth || 0}}升级</div>
    </div>
    <div class="my_integral_value flex Flexalign FlexBetween">
      <div class="flex FlexBaseline intergal_left">
        <div class="intergal_value">{{ signInfo.userCopperPoints }}</div>
        <div class="ml-10">铜币积分</div>
      </div>
      <div class="flex Flexalign rule_detail cursor_pointer" @click="showSignInRule">
        签到规则
        <el-image class="rule_detail_icon" :src="iconPath('rule_detail_icon.png')"></el-image>
      </div>
    </div>
    <div class="flex Flexalign integral_attention">
      <div>{{ signInfo.futureRewardInfo }}</div>
    </div>
    <div class="sign_list flex Flexalign FlexWrap FlexBetween">
      <div class="sign_one mt-10" v-for="(item, index) in signList" :key="index">
        <div class="sign_one_normal flex flexcolumn Flexjustify Flexalign" v-if="index != 6">
          <div>{{ `第${index + 1}天` }}</div>
          <el-image class="gold_coin_icon" :src="iconPath('gold_coin_icon.png')"
            v-if="item.recordState != 1"></el-image>
          <el-image class="gold_coin_icon" :src="iconPath('sign_in_success_icon.png')"
            v-if="item.recordState == 1"></el-image>
          <div class="sign_finish" v-if="item.recordState == 1">已签到</div>
          <!-- 有补签次数 -->
          <div class="sign_repair flex Flexalign FlexBetween cursor_pointer"
            v-if="item.recordState == 2 && signInfo.suppCount" @click="retroactiveSignIn(item)">
            <el-image class="signature_icon" :src="iconPath('signature_icon.png')"
              v-if="item.recordState == 2"></el-image>
            <div>可补签</div>
          </div>
          <!-- 无补签次数 -->
          <div class="sign_repair flex Flexalign Flexjustify" v-if="item.recordState == 2 && !signInfo.suppCount">
            <div>已过期</div>
          </div>
          <!-- <div class="sign_finish sign_reward_box" v-if="item.recordState == 0">已签到</div>
          <div class="sign_reward" v-if="item.recordState == 0">
            <div>{{ item.copperPoints }}铜币</div>
            <div>{{ item.honorValue }}EX</div>
          </div> -->
          <div class="sign_finish sign_reward_box" v-if="item.recordState == 0">已签到</div>
          <div class="sign_reward" v-if="item.recordState == 0" :class="[getIsTodaySignIn(item.day)]">
            <div>{{ item.copperPoints || 0 }}铜币</div>
            <!-- <div>{{ item.honorValue || 0 }}EX</div> -->
          </div>
        </div>
        <div class="sign_one_final flex flexcolumn Flexalign" v-if="index == 6">
          <div class="pt-10">{{ `第${index + 1}天` }}</div>
          <div class="flex Flexalign final_reward">
            <el-image class="sign_in_mysterious_icon" :src="iconPath('sign_in_mysterious_icon.png')"
              v-if="item.status != 1"></el-image>
            <div class="sign_reward sign_reward_wait">
              <div>{{ item.copperPoints || 0 }}铜币</div>
              <!-- <div>{{ item.honorValue || 0 }}EX</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_sign cursor_pointer" @click="signIn(0)">{{btnText}}</div>
    <signInSuccess ref="signInSuccess"></signInSuccess>
    <signInRule ref="signInRule"></signInRule>
    <confirm ref="confirm" :confirmText="confirmText" @signIn="signIn"></confirm>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "@/assets/utils/dbucTrtl";
import signInSuccess from "../popup/signInSuccess.vue";
import signInRule from "../popup/signInRule.vue";
import confirm from "@/components/popup/confirm.vue";
export default {
  name: "GjkcH5SignIn",
  components: {
    signInSuccess, signInRule, confirm
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  data() {
    return {
      signList: [],
      confirmText: "",
      signInParams: {
        signinId: 2,
        userId: '',
        memberLevelId: '',
        signinDayOfWeek: 7
      },
      signInfo: {},
      // 点击的补签day
      retroactiveSignInDay: '',
      btnText:'立即签到',
    };
  },

  mounted() {
    this.getSignInList();
  },

  methods: {
    // 计算等级百分比
    calculateProgress(current,next){
      if(!current){
        current = 0;
      }
      if(!next){
        next = 0;
      }
      let percentage = current / (current + next);
      return percentage*100;
    },
    getSignInList() {
      this.signInParams.memberLevelId = this.userInfo.memberLevelId;
      this.signInParams.userId = this.userInfo.buyerUserId;
      let today = new Date().getDay() + 1;
      this.signInParams.signinDayOfWeek = today;
      this.$Api.user.getSignInList(this.signInParams).then(res => {
        this.signInfo = res.data.data;
        let todayStatus = this.signInfo.daysList.filter(item => item.day == today)[0];
        if(todayStatus?.recordState == 1){
          this.btnText = '领更多铜币'
        }else{
          this.btnText = '立即签到'
        }
        this.signList = res.data.data.daysList;
        this.confirmText = `本周剩余可补签次数为 ${res.data.data.suppCount} 是否补签`
      }).catch(() => { })
    },
    // 判断是否是当天待签到
    getIsTodaySignIn(day) {
      let week = new Date().getDay();
      if ((week + 1) != day) {
        return 'sign_reward_wait'
      }
    },
    showSignInRule() {
      this.$refs.signInRule.signInRuleShow = true;
      this.$refs.signInRule.signInRuleContent = this.signInfo.rewardDescription;
    },
    // 提前创建防抖函数实例
    debouncedSignIn: debounce(function (type) { // ✅ 注意用 function 保留 this 指向
      const params = {
        userId: this.userInfo.buyerUserId,
        signinDayOfWeek: new Date().getDay() + 1,
        signinType: type,
        copperPoints: this.signInfo.copperPoints,
        honorValue: this.signInfo.honorValue,
        continueRewardDays: this.signInfo.continueRewardDays
      };
      // type 为1的情况是补签
      if (type == 1) {
        let retroactiveSignIn = this.signList.filter(item => item.day == this.retroactiveSignInDay)[0];
        if (this.$Tools.empty(retroactiveSignIn)) {
          this.$Dialog.toast('补签失败', { type: 'warning' });
          this.$refs.confirm.confirmShow = false;
          return
        }
        params.copperPoints = retroactiveSignIn.copperPoints;
        params.honorValue = retroactiveSignIn.honorValue;
        params.signinDayOfWeek = retroactiveSignIn.day;
      }
      params.signinId = this.signInParams.signinId;
      this.$Api.user.signIn(params).then(() => {
        this.$refs.signInSuccess.signInSuccessShow = true;
        this.$refs.signInSuccess.signSuccessInfo.copperPoints = params.copperPoints;
        this.$refs.signInSuccess.signSuccessInfo.honorValue = params.honorValue;
        this.getSignInList();
        this.$refs.confirm.confirmShow = false; // 关闭补签弹窗
      }).catch(() => { 
        this.$refs.confirm.confirmShow = false;
      })
      // 此处调用实际接口
    }, 500),

    // 事件触发方法
    signIn(type) {
      if (type == 0) {
        let today = new Date().getDay();
        if (this.signList[today]?.recordState == 1) {
          // this.$Dialog.toast("今天已经签过到了");
          this.$Jump.href('/integralCenter');
          return
        }
      }
      this.debouncedSignIn(type); // ✅ 调用已防抖处理的函数
    },
    // 补签
    retroactiveSignIn(info) {
      this.$refs.confirm.confirmShow = true;
      this.retroactiveSignInDay = info.day;
    },
    // 积分中心
    goIntegralCenter(){
      this.$Jump.href('/integralCenter');
    }
  },
};
</script>
<style lang="scss" scoped>
.sign_in_box {
  position: relative;
  width: 100%;
  box-sizing: border-box;

  .top_bg {
    position: absolute;
    width: 100%;
    top: 0;

    .points_top_bg {
      width: 100%;
      height: 170px;
    }
  }

  .my_integral_box {
    padding: 10px 20px;
    padding-top: 30px;
    width: 100%;
    box-sizing: border-box;
    z-index: 9;

    .headImage {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .user_name {
      font-size: 14px;
      color: #111111;
      max-width: 200px;
    }

    .member_level_gold_icon {
      width: 58px;
      height: 28px;
    }
    .integral_cenetr{
      position: absolute;
      right: 20px;
    }
  }

  .progress_box {
    padding: 10px 20px;
    font-size: 12px;
    color: #909090;
    z-index: 9;

    :deep(.el-progress-bar__outer) {
      background-color: #ffffff;
    }
  }

  .my_integral_value {
    padding: 0 20px;
    position: relative;

    .intergal_left {
      font-size: 12px;
      color: #909090;

      .intergal_value {
        font-weight: bold;
        font-size: 26px;
        color: #303030;
      }
    }

    .rule_detail {
      font-size: 12px;
      color: #ff4f00;
    }

    .rule_detail_icon {
      width: 16px;
      height: 16px;
      margin-left: 6px;
    }
  }

  .integral_attention {
    padding: 0 20px;
    font-size: 13px;
    color: #666666;
    z-index: 10;
    position: relative;

    .btn_integral {
      margin-left: 10px;
      width: 65px;
      height: 24px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 12px;
      border: 1px solid #ffffff;
      line-height: 24px;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #ff7a24;

      .points_icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  .sign_list {
    padding: 0 20px;

    .sign_one {
      .sign_one_normal {
        width: 90px;
        height: 114px;
        background: #f7f7f7;
        border-radius: 6px;
        position: relative;

        .gold_coin_icon {
          width: 50px;
          height: 50px;
        }

        .sign_finish {
          font-size: 12px;
          color: #ff4f00;
        }

        .sign_repair {
          font-size: 12px;
          color: #13d6aa;
          width: 60px;

          .signature_icon {
            width: 15px;
            height: 15px;
          }
        }

        .sign_reward {
          font-size: 12px;
          color: #ff4f00;
          position: absolute;
          bottom: 8px;
        }

        .sign_reward_wait {
          color: #606060;
        }

        .sign_reward_box {
          opacity: 0;
        }
      }

      .sign_one_final {
        width: 301px;
        height: 114px;
        background: #f7f7f7;
        border-radius: 6px;

        .final_reward {
          .sign_in_mysterious_icon {
            width: 86px;
            height: 86px;
          }

          .sign_reward_wait {
            font-size: 12px;
            color: #606060;
          }
        }
      }
    }
  }

  .btn_sign {
    width: 302px;
    height: 53px;
    background: #ff5001;
    box-shadow: 0px 6px 8px 0px rgba(255, 80, 1, 0.17);
    border-radius: 27px;
    font-size: 18px;
    color: #ffffff;
    line-height: 53px;
    text-align: center;
    margin: 20px auto;
  }
}
</style>
